import {
  Box,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Button,
  Divider,
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  DialogTitle,
  Tooltip,
  Checkbox,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../axiosInstance";
import { baseUrl } from "../../environment";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete"; // Import delete icon
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";

function LegalAnalyzerQuestions() {
  const [answers, setAnswers] = useState({});
  const [questions, setQuestions] = useState([]); // Store both API and custom questions
  const [clauses, setClauses] = useState([]); // Store both API and custom questions
  const [selectedQuestions, setSelectedQuestions] = useState({});
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [open, setOpen] = useState(false);
  const [resultDescription, setResultDescription] = useState("");
  const [resultColor, setResultColor] = useState("#000");
  const navigate = useNavigate();

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    localStorage.removeItem("ContractAssistData");
    navigate("/dashboard/legal-analyzer");
  };

  const handleInputChangeForQuestions = (event, questionText) => {
    const { value } = event.target;
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [`${questionText}_other`]: value,
    }));
  };

  const handleOptionChange = (questionText, selectedOption) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionText]: selectedOption,
    }));
  };

  const handleCheckboxChange = (event, questionText) => {
    const checked = event.target.checked;
    setSelectedQuestions((prevSelected) => ({
      ...prevSelected,
      [questionText]: checked,
    }));
    // Clear answer if unchecked
    if (!checked) {
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [questionText]: "",
        [`${questionText}_other`]: "",
      }));
    }
  };

  const handleClauseClick = (questionText) => {
    // Toggle the checkbox state when clicking the clause text
    const isChecked = !selectedQuestions[questionText];
    setSelectedQuestions((prevSelected) => ({
      ...prevSelected,
      [questionText]: isChecked,
    }));
    // Clear answer if unchecked
    if (!isChecked) {
      setAnswers((prevAnswers) => ({
        ...prevAnswers,
        [questionText]: "",
        [`${questionText}_other`]: "",
      }));
    }
  };

  // const handleAnalyze = async () => {
  //   // Filter the selected questions
  //   const filteredQuestions = Object.keys(selectedQuestions).filter(
  //     (key) => selectedQuestions[key]
  //   );

  //   // Format the data to include clauses, questions, and answers
  //   const formattedData = {
  //     contract_data: filteredQuestions.map((question, index) => ({
  //       clause: clauses[index], // Use the index to fetch the corresponding clause
  //       question: question,
  //       answer:
  //         answers[question] === "Other"
  //           ? answers[`${question}_other`] // If answer is "Other", get the "Other" value
  //           : answers[question], // Else, use the selected answer
  //     })),
  //   };

  //   try {
  //     // Send the formatted data to the server
  //     const res = await axiosInstance.post(
  //       baseUrl + "Law/AnalyzeContractAssistResult",
  //       formattedData
  //     );

  //     // Handle the response from the server
  //     setResultDescription(res?.data?.data?.description);
  //     setResultColor(
  //       res?.data?.data?.color.toLowerCase() === "blue"
  //         ? "#FFBF00" // Use a custom color if the color is blue
  //         : res?.data?.data?.color.toLowerCase() // Otherwise, use the color from the response
  //     );

  //     handleClickOpen(); // Open the result dialog
  //   } catch (error) {
  //     console.error("Error analyzing contract data:", error);
  //     // Optionally, handle the error or show a user-friendly message
  //   }
  // };

  const handleAnalyze = async () => {
    // Filter the selected questions
    const filteredQuestions = Object.keys(selectedQuestions).filter(
      (key) => selectedQuestions[key]
    );

    // Validate that all selected questions have answers
    for (const question of filteredQuestions) {
      const answer =
        answers[question] === "Other"
          ? answers[`${question}_other`]
          : answers[question];
      if (!answer) {
        setTimeout(() => {
          toast.warning(
            `Please select an answer for the question: "${question}"`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }, 200);
        return; // Stop the function execution
      }
    }

    // Format the data to include clauses, questions, and answers
    const formattedData = {
      contract_data: filteredQuestions.map((question, index) => ({
        clause: clauses[index], // Use the index to fetch the corresponding clause
        question: question,
        answer:
          answers[question] === "Other"
            ? answers[`${question}_other`] // If answer is "Other", get the "Other" value
            : answers[question], // Else, use the selected answer
      })),
    };

    try {
      // Send the formatted data to the server
      const res = await axiosInstance.post(
        baseUrl + "Law/AnalyzeContractAssistResult",
        formattedData
      );

      // Handle the response from the server
      setResultDescription(res?.data?.data?.description);
      setResultColor(
        res?.data?.data?.color.toLowerCase() // Otherwise, use the color from the response
      );
      // setResultColor(
      //   res?.data?.data?.color.toLowerCase() === "blue"
      //     ? "#000" // Use a custom color if the color is blue
      //     : res?.data?.data?.color.toLowerCase() // Otherwise, use the color from the response
      // );
      handleClickOpen(); // Open the result dialog
    } catch (error) {
      console.error("Error analyzing contract data:", error);
      // Optionally, handle the error or show a user-friendly message
    }
  };

  const handleDoubleClick = (index) => setEditingQuestion(index);

  const handleEditChange = (event, index) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index].text = event.target.value; // Update only the text of the specific question
    setQuestions(updatedQuestions); // Update the entire questions array
  };

  const handleEditBlur = () => setEditingQuestion(null);

  // Function to add a custom question
  const handleAddQuestion = () => {
    const newQuestion = `Enter your question`; // Default question text
    setQuestions((prevQuestions) => [
      ...prevQuestions,
      { text: newQuestion, isCustom: true }, // Mark question as custom
    ]);
  };

  // Function to delete a custom question
  const handleDeleteQuestion = (index) => {
    const updatedQuestions = questions.filter(
      (_, i) => i !== index || !questions[i].isCustom // Only delete if it's a custom question
    );
    setQuestions(updatedQuestions);
  };

  useEffect(() => {
    const storedData = localStorage.getItem("ContractAssistData");
    if (storedData) {
      const parseData = JSON.parse(storedData);
      const parties = JSON.parse(parseData?.clauses_and_questions);
      const formattedQuestions = Object.values(parties).map((question) => ({
        text: question,
        isCustom: false, // Mark API questions as not custom
      }));
      setQuestions(formattedQuestions);
      setClauses(Object.keys(parties));
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#1e1e2f",
          padding: "30px",
          borderRadius: "10px",
          color: "#fff",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
        }}
      >
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 600 }}>
          Clauses and Questions
        </Typography>
      </Box>

      <Box sx={{ minWidth: "100%", marginTop: "20px" }}>
        <Grid container spacing={3}>
          {questions.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Box
                sx={{
                  backgroundColor: "#2c2f3b",
                  borderRadius: "8px",
                  padding: "20px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                  marginBottom: "20px", // Adding space between questions
                }}
              >
                <Box display="flex" flexDirection="row" alignItems="center">
                  <Checkbox
                    checked={selectedQuestions[item.text] || false}
                    onChange={(event) => handleCheckboxChange(event, item.text)}
                    sx={{
                      color: "#FFBF00",
                      "&.Mui-checked": {
                        color: "#FFBF00",
                      },
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#fff",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleClauseClick(item.text)} // Clicking on the clause text will toggle the checkbox
                  >
                    Clause: {clauses[index]}
                  </Typography>
                </Box>

                <Box sx={{ marginLeft: "43px" }}>
                  <Tooltip title="Double-click to modify this question" arrow>
                    {editingQuestion === index ? (
                      <TextField
                        fullWidth
                        value={item.text}
                        onChange={(event) => handleEditChange(event, index)}
                        onBlur={handleEditBlur}
                        autoFocus
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "5px",
                          padding: "8px",
                          marginTop: "8px",
                        }}
                      />
                    ) : (
                      <Typography
                        variant="h6"
                        onDoubleClick={() => handleDoubleClick(index)}
                        sx={{
                          color: "#fff",
                          fontWeight: "500",
                          marginTop: "-8px",
                          cursor: "pointer",
                        }}
                      >
                        Question {index + 1}: {item.text}
                      </Typography>
                    )}
                  </Tooltip>
                </Box>

                {/* Delete button for custom questions */}
                {editingQuestion !== index && item.isCustom && (
                  <IconButton
                    color="error"
                    onClick={() => handleDeleteQuestion(index)}
                    sx={{
                      marginTop: "10px",
                      color: "#FF5252",
                      "&:hover": {
                        color: "#D32F2F",
                      },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )}

                <RadioGroup
                  row
                  name={item.text}
                  value={answers[item.text] || ""}
                  onChange={(event) =>
                    handleOptionChange(item.text, event.target.value)
                  }
                  sx={{ marginTop: "15px" }}
                >
                  <FormControlLabel
                    value="Yes"
                    control={<Radio disabled={!selectedQuestions[item.text]} />}
                    label="Yes"
                    sx={{ color: "#fff" }}
                  />
                  <FormControlLabel
                    value="No"
                    control={<Radio disabled={!selectedQuestions[item.text]} />}
                    label="No"
                    sx={{ color: "#fff" }}
                  />
                  <FormControlLabel
                    value="Other"
                    control={<Radio disabled={!selectedQuestions[item.text]} />}
                    label="Other"
                    sx={{ color: "#fff" }}
                  />
                </RadioGroup>

                {answers[item.text] === "Other" &&
                  selectedQuestions[item.text] && (
                    <TextField
                      placeholder="Please specify"
                      multiline
                      fullWidth
                      value={answers[`${item.text}_other`] || ""}
                      onChange={(event) =>
                        handleInputChangeForQuestions(event, item.text)
                      }
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        padding: "10px",
                        marginTop: "8px",
                      }}
                    />
                  )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Divider sx={{ margin: "30px 0" }} />

      {/* Add button to add a new question */}
      <Box
        sx={{ margin: "15px 0", display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          size="small"
          onClick={handleAddQuestion}
          sx={{
            backgroundColor: "#FFBF00",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#FF8000",
            },
          }}
        >
          <AddCircleIcon />
          &nbsp; Add Question
        </Button>
      </Box>

      <Divider sx={{ margin: "30px 0" }} />

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={handleAnalyze}
          sx={{
            backgroundColor: "#1e88e5",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#1976d2",
            },
          }}
        >
          Proceed to Analyse
        </Button>
      </Box>

      <Divider sx={{ marginTop: "30px" }} />

      <Dialog open={open} onClose={handleClose} maxWidth={"md"}>
        <DialogTitle textAlign={"left"}>Result</DialogTitle>
        <Divider />
        <DialogContent style={{ backgroundColor: resultColor === 'blue' ? 'rgb(255, 255, 0)' : resultColor }}>
          <Typography
            variant="body1"
            gutterBottom
            textAlign={"left"}
            color={"white"}
            fontWeight={"bold"}
            fontSize={"25px"}
          >
            <div
            className="trafic-light-container"
            >
              <div class="traffic-light">
                <div
                  class="light red"
                  style={{
                    backgroundColor:
                      resultColor.toLowerCase() === "red"
                        ? "rgb(255, 0, 0)"
                        : "rgba(255, 0, 0, 0.425)",
                  }}
                ></div>
                <div
                  class="light yellow"
                  style={{
                    backgroundColor:
                      resultColor.toLowerCase() === "blue"
                        ? "rgb(255, 255, 0)"
                        : "rgba(255, 255, 0, 0.363)",
                  }}
                ></div>
                <div
                  class="light green"
                  style={{
                    backgroundColor:
                      resultColor.toLowerCase() === "green"
                        ? "rgb(64, 255, 6)"
                        : "rgba(0, 128, 0, 0.267)",
                  }}
                ></div>
              </div>
              <div style={{ marginLeft: "15px" }}>
                {resultColor.toLowerCase() === "red" && (
                  <div>
                    <span style={{ fontWeight: "bolder", fontSize: "1.5rem" }}>
                      ❌ High Risk: Escalate Before Signing
                    </span>
                    <br />
                    <span style={{ fontSize: "1.5rem", fontWeight: "lighter" }}>
                      Major risks identified. Escalate to legal review or
                      renegotiate the flagged terms. Do not proceed to sign
                      until all issues are resolved.
                    </span>
                  </div>
                )}
                {resultColor.toLowerCase() === "blue" && (
                  <div style={{color:"#000"}}>
                    <span style={{ fontWeight: "bolder", fontSize: "1.5rem" }}>
                      ⚠ Review Required Before Signing
                    </span>
                    <br />
                    <span style={{ fontSize: "1.5rem", fontWeight: "lighter" }}>
                      Certain conditions need clarification or adjustments.
                      Resolve the highlighted issues and consult with relevant
                      stakeholders before proceeding to sign.
                    </span>
                  </div>
                )}
                {resultColor.toLowerCase() === "green" && (
                  <div>
                    <span style={{ fontWeight: "bolder", fontSize: "1.5rem" }}>
                      No Risk Identified:{" "}
                    </span>
                    <span style={{ fontSize: "1.5rem", fontWeight: "lighter" }}>
                      All requirements met. Ready for approval and execution.
                    </span>
                    <br />
                    <span style={{ fontWeight: "bolder", fontSize: "1.5rem" }}>
                      Green Light:{" "}
                    </span>
                    <span style={{ fontSize: "1.5rem", fontWeight: "lighter" }}>
                      Clear signal to move forward, no additional action needed.
                    </span>
                  </div>
                )}
                {/* {resultDescription} */}
              </div>
            </div>
          </Typography>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default LegalAnalyzerQuestions;
